export const isMobile = () => {
	return document.body.clientWidth <= 992;
};

export const scrollingTo = function(element) {
	if (element) {
		const target = element;
		const scrollEl = window.BrandLib.consts.scrollingElement;

		window.BrandLib.general.AnimScroll(
			scrollEl,
			target.offsetTop + (document.body.clientWidth <= 768 ? -10 : -10),
			700
		);
	} else {
		console.error(
			"[React BrandLib]: scrollingTo() Null or Undefined element was passed."
		);
	}
};
